import { render, staticRenderFns } from "./CarrierFiles.vue?vue&type=template&id=560b1ae8"
import script from "./CarrierFiles.vue?vue&type=script&lang=js"
export * from "./CarrierFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports